export const transformCommon2ShipStructure = (data = {}) => {
  const {
    status,
    distance,
    update_time,
    code,
    driver,
    shipping_fee_origin,
    booking_service_type,
    customer_note,
    driver_location,
    drop_infos,
    booking_type,
    create_time,
    booking_service_name,
    pick_info,
    shipping_fee,
    paid_status,
    data_by_status,
  } = data;

  const {
    item_value,
    booking_sharing_url,
    receiver_bill,
    recipient_info,
    drop_address_info, // Note: 这里包含了 usename 这些内容，多了一些字段
    recipient_labels,
  } = drop_infos[0] || {};

  const {
    pick_address_info,
    sender_bill,
    sender_info,
  } = pick_info || {};

  return {
    status,
    update_time,
    code,
    driver,
    drop_address_info,
    item_value,
    booking_service_type,
    sender_info,
    customer_note,
    pick_address_info,
    create_time,
    booking_service_name,
    distance,
    sender_bill,
    shipping_fee,
    recipient_labels,
    receiver_bill,
    paid_status,
    shipping_fee_origin,
    booking_sharing_url,
    booking_type,
    data_by_status,
    recipient_info,
    driver_location,
  }
}